import { EcpLocator } from '../ecp-locator';
// import { Wiki } from '../wiki';
import { SignUpBanner } from '../sign-up-banner';
import { PrimaryBannerUnregistered } from '../primary-banner-unregistered';
import { DownloadApp } from '../../download-app';
import { useStyles } from './landing-page-not-logged-in.styles';
import { Simulator } from '../simulator';
import { v2026PP13733 } from '../../../../../constants/veeva';
import { Veeva } from '../../../../common/veeva';
import { Video } from '../video';

export const LandingPageNotLoggedIn = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <SignUpBanner />
      <DownloadApp />
      <Video />
      <PrimaryBannerUnregistered />
      <EcpLocator isLoggedIn={false} />
      <div className={classes.simulator}>
        <Simulator />
      </div>
      { /* <div className={classes.coloredSection}> */ }
      { /*  <Wiki /> */ }
      { /* </div> */ }
      <Veeva
        veevaNumber={v2026PP13733}
        isRight
        // backgroundColor="#ebfaff"
      />
    </>
  );
};
